export enum DefaultLandingPages {
  Home = 'HOME',
  ConciergeHub = 'CONCIERGE_HUB',
}
